export default __webpack_public_path__ + "static/media/p11.117ac162.png";